































import { Vue, Component, Prop } from 'vue-property-decorator';
import IAccordion from '@/core/ui-components/IAccordion';

@Component
export default class Accordion extends Vue implements IAccordion {
    @Prop({ type: String, default: 'div' }) tag!: string;
    @Prop({ type: String, default: 'div' }) bodyTag!: string;
    @Prop({ type: String, default: '' }) headerClass!: string;
    @Prop({ type: String, default: 'arrow-down' }) icon!: string;

    @Prop({ type: Boolean, default: false }) multiple!: boolean;
    @Prop({ type: Boolean, default: false }) disabled!: boolean;
    @Prop({ type: Boolean, default: false }) expanded!: boolean;
    @Prop({ type: Boolean, default: false }) hideHeader!: boolean;
    @Prop({ type: Boolean, default: false }) keepAlive!: boolean;
    @Prop({ type: Boolean, default: false }) allowToggle!: boolean;

    private isExpanded: boolean = false;

    created() {
        this.isExpanded = this.expanded;
    }

    public close() {
        this.isExpanded = false;
    }

    public open(): void {
        this.isExpanded = true;
    }

    private toggle(e: any) {
        if (this.disabled) return;

        this.allowToggle && (this.isExpanded = !this.isExpanded);

        if (this.multiple) return;

        // Close the rest
        this.$parent!.$children.forEach(child => {
            if (child instanceof Accordion && child !== this) {
                child.isExpanded = false;
            }
        });
    }

    private setFixedHeight(el: HTMLElement) {
        el.style.height = el.scrollHeight + 'px';
    }

    private setAutoHeight(el: HTMLElement) {
        el.style.height = 'auto';
    }
}
